import { createContext } from 'react';
import { LoginRequestDTO } from '../../application/dtos/login-request.dto';

export interface UserState {
  id: string;
  email: string;
  fullName?: string | null;
  role?: string;
  permissions?: string[];
}

export interface AuthContextType {
  isAuthenticated: boolean;
  user: UserState | null;
  role: string | null;
  permissions: string[];
  hasPermission: (code: string) => boolean;
  loading: boolean;
  login: (credentials: LoginRequestDTO) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
